import { Validators } from '@quickbit/qb-design-system';
import { Platform } from 'tabs/types';

export const platformValidators: Validators<Platform, Platform> = {
  name: (name: string) => (name.length < 1 ? 'Can not be empty.' : undefined),
};
